import React from "react";
import "../dashboard.css";

export default function Miembros() {
    return (
        <div>
            <h1 className="dashboardTitle">Gestión de Miembros</h1>
            <p className="dashboardSubtitle">Próximamente: Base de datos de miembros de la iglesia.</p>
        </div>
    );
}
